import React from 'react';
import { useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';

import Form from '/src/components/form/Form';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import TextArea from '/src/components/UI/TextField/TextArea';
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import languages from '/src/data/dropdown/languages';
import Button from "../../../../../components/UI/Button/Button";
import DatasetFormTypes from '../../../data/types/DatasetFormTypes.js';
import datasetService from '/src/features/dataset/services/datasetService';
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
import DatasetTypes from '/src/features/dataset/data/types/DatasetTypes';
import "./DatasetForm.css";

function DatasetForm({ data, type: mode }) {

	let navigate = useNavigate();

	const formData = DatasetFormTypes[mode];

	formData.values = data;
	var isUpdateMode = mode != 'create';
	const { addDataset, updateDataset, isDatasetNameAvailable } = datasetService;
	const { register, clearErrors, handleSubmit, watch, setError, formState: { errors }, formState, getValues, setValue } = useForm({
		mode: "onChange",
		defaultValues: {
			name: isUpdateMode ? formData.values.name : "",
			description: isUpdateMode ? formData.values.description : "",
			language: isUpdateMode ? formData.values.language.slug.toLowerCase() : "fr",
			public: isUpdateMode ? formData.values.public : 0,
			dataset_type_id: isUpdateMode ? formData.values.dataset_type_id : 1,
		}
	});

	const checkNameAvailability = async (name) => {
		if (data?.name === name) return true;
		if (name.length < 3) return false;
		var [response, errors] = await isDatasetNameAvailable(name)
		if (errors != null) {
			console.log(errors)
			return;
		}

		response = response.filter(bot => bot.name == name);
		if (response.length == 1) {
			setError("name", { type: 'focus', message: 'Oups this name is already taken' })
		}
		else {
			clearErrors("name")
			return true;
		}

	}

	const onSubmit = async () => {
		const dataToSend = getValues();
		dataToSend.name = dataToSend.name.trim();
		let nameAvailable = await checkNameAvailability(dataToSend.name)

		if (nameAvailable != true) return;
		dataToSend.language = dataToSend.language.toUpperCase();
		let [response, errors] = isUpdateMode ? await updateDataset(formData.values.id, dataToSend) : await addDataset(dataToSend)

		return navigate(urlWithRoutingCompany('/datasets/list'));
	}


	return (
		<Form onSubmit={handleSubmit(onSubmit)} className={"faq_form_container"}>
			<Form.Title>{formData.title}</Form.Title>
			<Form.Body>
				<div>
					<Field label={<span>🌎 Public Mode</span>} listLabelClassName="titles-input" listClassName="flex switch_form_faq">
						<div style={{ width: "150px", display: "flex", justifyContent: "center" }}>
							<CheckBox setValue={setValue}{...register('public')} checked={getValues("public")} />
						</div>
					</Field>
				</div>
				<div className="botForm-container">
					<Field label="Name" listLabelClassName="titles-input">
						<TextInput {...register('name', { required: true, minLength: 3, onChange: (e) => checkNameAvailability(e.target.value) })} style={errors.name ? { borderColor: "red" } : {}} />
						<span className='error'>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
					</Field>
				</div>
				<div className="botForm-container">
					<Field label="Description" listLabelClassName="titles-input">
						<TextArea style={{ height: '40px' }} {...register('description', { required: true })}></TextArea>
					</Field>
				</div>
				<div style={{ marginTop: "25px", marginBottom: '25px', display: "flex" }}>
					<Field label="Select your data type" listLabelClassName="titles-input"></Field>
					<div style={{ marginLeft: "5%", marginTop: "2%" }}>
						<Dropdown {...register('dataset_type_id')} setValue={setValue} choices={DatasetTypes} defaultChoice={mode == "update" ? watch('dataset_type_id') : 1} width="185px" disabled={mode == "update"}></Dropdown>
					</div>
				</div>
				{
					watch('dataset_type_id') == 1 ? <div style={{ marginTop: "25px", marginBottom: '25px', display: "flex" }}>
						<Field label="Select your language" listLabelClassName="titles-input"></Field>
						<div style={{ marginLeft: "5%", marginTop: "2%" }}>
							<Dropdown {...register('language')} setValue={setValue} choices={languages} defaultChoice={mode == "update" ? formData.values.language.slug.toLowerCase() : "fr"} disabled={mode == "update"} width="185px"></Dropdown>
						</div>
					</div> : null
				}
			</Form.Body>
			<Form.Buttons>
				<Button type="submit" label={formData.send} className="validate" disabled={!formState.isValid} />
			</Form.Buttons>
		</Form >
	)

}

DatasetForm.defaultProps = {
	data: { public: true },
	type: 'create'
}

export default DatasetForm;